var storage = {
  state: {},
  getters: {
    getPermission: function getPermission(state) {
      return JSON.parse(sessionStorage.getItem("permission"));
    }
  },
  mutations: {},
  actions: {}
};
export default storage;